import { Button } from "@/components/ui/button";
import { Receipt } from "lucide-react";

export default function CheckoutReceipt({ receipt, spot, lot, customer, onClose }) {
  const row = (label, value, testid, bold) => (
    <div key={testid || label} className={`flex justify-between ${bold ? "border-t border-slate-800 pt-2 text-base font-bold text-slate-100" : "text-slate-400"}`}>
      <span>{label}</span>
      <span data-testid={testid}>{value}</span>
    </div>
  );
  const collected = (receipt.balanceCollections || []).reduce((a, c) => a + c.amount, 0);
  return (
    <div data-testid="checkout-receipt" className="space-y-4 py-2">
      <div className="text-center">
        <Receipt className="mx-auto h-12 w-12 text-[#A0148C]" />
        <p className="mt-2 text-sm uppercase tracking-[0.2em] text-slate-400">Receipt</p>
        <p data-testid="receipt-ticket-number" className="font-data text-2xl font-black text-[#d946ef]">
          {receipt.ticketNumber || "—"}
        </p>
      </div>
      <div className="space-y-1 rounded-lg border border-slate-800 bg-slate-950 p-4 font-data text-sm">
        {row("Lot / Spot", `${lot?.name || ""} #${spot?.spotNumber || ""}`)}
        {row("Driver", customer?.name || "—")}
        {receipt.prepaid ? (
          <>
            {receipt.openEnded && row("Stay type", "Open-ended (auto-charge)", "receipt-open-ended")}
            {receipt.daysPaid != null && row("Days paid on card", `${receipt.daysPaid}`, "receipt-days-paid")}
            {receipt.paidDays && !receipt.openEnded && row("Days booked", `${receipt.paidDays}`, "receipt-paid-days")}
            {receipt.paidUntil && row("Paid through", new Date(receipt.paidUntil).toLocaleString(), "receipt-paid-until")}
            {(receipt.autoCharges || []).map((c) => row(
              `Auto-charge #${c.cycle} · ${c.status}${c.approvalCode ? ` · ${c.approvalCode}` : ""}${c.cardLast4 ? ` · ****${c.cardLast4}` : ""}`,
              `$${Number(c.amount || 0).toFixed(2)}`,
              `receipt-autocharge-${c.cycle}`,
            ))}
            {receipt.balanceDaysCollected > 0 && row(
              "Unpaid days collected at checkout",
              `${receipt.balanceDaysCollected || 0} · $${collected.toFixed(2)}`,
              "receipt-balance-collected",
            )}
            {receipt.balanceWriteOff && row(
              `Written off by ${receipt.balanceWriteOff.byName}`,
              `${receipt.balanceWriteOff.days} day(s) · -$${receipt.balanceWriteOff.amount.toFixed(2)}`,
              "receipt-write-off",
            )}
            {row("Final total paid", `$${Number(receipt.finalTotal ?? receipt.prepaidAmount).toFixed(2)}`, "receipt-final-total", true)}
          </>
        ) : (
          <>
            {row("Base", `$${receipt.base.toFixed(2)}`)}
            {row(`Sales tax (${receipt.taxPercent ?? 0}%)`, `$${receipt.tax.toFixed(2)}`)}
            {row("Method", receipt.method)}
            {row("Total captured", `$${receipt.captured.toFixed(2)}`, "receipt-total", true)}
          </>
        )}
      </div>
      <Button
        data-testid="receipt-done"
        onClick={onClose}
        className="h-12 w-full bg-[#A0148C] font-bold hover:bg-[#80106F]"
      >
        Done
      </Button>
    </div>
  );
}
